module.exports = __webpack_public_path__ + "static/img/main_bg.3299f0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main_bg.png
// module id = NRWh
// module chunks = 1